import { render, staticRenderFns } from "./subjectTree.vue?vue&type=template&id=a44093ae&"
import script from "./subjectTree.vue?vue&type=script&lang=js&"
export * from "./subjectTree.vue?vue&type=script&lang=js&"
import style0 from "./subjectTree.vue?vue&type=style&index=0&id=a44093ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports